/*Hashtagify hashes*/

const pattern = /#(\S+)/ig;

const FeedHashtagify = (contentStr) => {
    return contentStr.replace(pattern, (match, p1) => {
        // console.log(match, ' - ', p1);
        let replacement = match;
        replacement = `<a href='/feed/hash/${p1}'>#${p1}</a> `;

        return replacement;
    });
}

export default FeedHashtagify;